import { useTheme } from '@emotion/react';
import { useMediaQuery as useMuiMediaQuery } from '@mui/material';

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | number;

export const useMediaQuery = (breakpoint: Breakpoint) => {
  const theme = useTheme();

  let query = '';

  if (typeof breakpoint === 'number') {
    query = `(min-width:${breakpoint}px)`;
  }

  const matches = useMuiMediaQuery(query || theme.breakpoints.down(breakpoint));
  return matches;
};
